import { useEffect, useState, type CSSProperties } from 'react';
import m from './MemberAvatar.module.css';

/**
 * A member's face for the builder and the launcher (architecture §14.79, §14.85): the photo or
 * illustration at `avatarUrl`, laid over the initial so the initial shows until it loads (and stays
 * if it fails). Size, tint and type come from `className`/`style`, so each surface keeps its look;
 * illustrations are transparent and show the tint. With an image, its alt text is the member's
 * name. The join page's member list does not use it (no avatars before a device is bound).
 */
export function MemberAvatar({
  name,
  avatarUrl,
  className,
  style,
}: {
  name: string;
  avatarUrl?: string | undefined;
  className?: string | undefined;
  style?: CSSProperties | undefined;
}) {
  const [failedUrl, setFailedUrl] = useState<string | null>(null);
  useEffect(() => setFailedUrl(null), [avatarUrl]);
  const photo = avatarUrl !== undefined && failedUrl !== avatarUrl ? avatarUrl : null;
  return (
    <span className={className ? `${m.root} ${className}` : m.root} style={style} aria-hidden={photo === null ? true : undefined}>
      <span aria-hidden>{(Array.from(name.trim())[0] ?? '?').toUpperCase()}</span>
      {photo !== null && (
        <img className={m.photo} src={photo} alt={name} decoding="async" onError={() => setFailedUrl(photo)} />
      )}
    </span>
  );
}
